import { FormGroup } from "@angular/forms";

export const formHasAllEmptyValues = (form: FormGroup<any>): boolean => {
  const isControlValueEmpty = Object.values(form.controls).map((control) => {
    const value = control.value;
    return !!value;
  });

  return isControlValueEmpty.every((value) => !value);
};
